(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const searchInputHeader = document.querySelector('.ec-header__search-input');
    const searchPopular = document.getElementById('ec-search-popular');
    
    if (!searchInputHeader || !searchPopular) {
      return;
    }

    const searchDefault = document.getElementById('ec-search-popular-default');
    const searchPredictive = document.getElementById('ec-search-predictive');
    const searchPredictiveResults = document.getElementById('ec-search-predictive-results');
    const searchPredictiveLoading = document.getElementById('ec-search-predictive-loading');
    
    let abortController = null;
    let cachedResults = {};
    let currentSearchTerm = '';
    let searchTimeout;
    
    const getPredictiveSearchResults = (searchTerm) => {
      if (!searchTerm || searchTerm.trim().length < 2) {
        if (searchDefault) searchDefault.style.display = 'block';
        if (searchPredictive) searchPredictive.style.display = 'none';
        return;
      }
      
      const queryKey = searchTerm.trim().toLowerCase();
      
      if (abortController) {
        abortController.abort();
      }
      abortController = new AbortController();
      
      if (searchDefault) searchDefault.style.display = 'none';
      if (searchPredictive) searchPredictive.style.display = 'block';
      if (searchPredictiveLoading) searchPredictiveLoading.style.display = 'block';
      if (searchPredictiveResults) searchPredictiveResults.innerHTML = '';
      
      if (cachedResults[queryKey]) {
        renderPredictiveResults(cachedResults[queryKey], searchTerm);
        if (searchInputHeader) {
          searchInputHeader.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      
      const predictiveSearchUrl = window.Shopify?.routes?.predictive_search_url || '/search/suggest';
      const url = `${predictiveSearchUrl}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`;
      
      fetch(url, {
        signal: abortController.signal,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const resultsMarkup = doc.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
          
          cachedResults[queryKey] = resultsMarkup;
          
          renderPredictiveResults(resultsMarkup, searchTerm);
          
          if (searchInputHeader) {
            searchInputHeader.setAttribute('aria-expanded', 'true');
          }
        })
        .catch((error) => {
          if (error?.code === 20 || error?.name === 'AbortError') {
            return;
          }
          console.error('Erro ao buscar resultados:', error);
          if (searchDefault) searchDefault.style.display = 'block';
          if (searchPredictive) searchPredictive.style.display = 'none';
          if (searchInputHeader) {
            searchInputHeader.setAttribute('aria-expanded', 'false');
          }
        });
    };
    
    const clearSelection = () => {
      const selected = searchPredictive?.querySelector('[aria-selected="true"]');
      if (selected) {
        selected.setAttribute('aria-selected', 'false');
      }
      if (searchInputHeader) {
        searchInputHeader.setAttribute('aria-activedescendant', '');
      }
    };
    
    const renderPredictiveResults = (resultsMarkup, searchTerm) => {
      if (searchPredictiveLoading) searchPredictiveLoading.style.display = 'none';
      
      if (!resultsMarkup || resultsMarkup.trim() === '') {
        if (searchPredictiveResults) {
          searchPredictiveResults.innerHTML = '<div class="ec-search-predictive__no-results">Nenhum resultado encontrado</div>';
        }
        return;
      }
      
      if (searchPredictiveResults) {
        searchPredictiveResults.innerHTML = resultsMarkup;
        
        const queriesList = searchPredictiveResults.querySelector('#predictive-search-results-queries-list');
        if (queriesList) {
          queriesList.classList.add('ec-predictive-search__suggestions-list');
          const queryItems = queriesList.querySelectorAll('.predictive-search__list-item');
          queryItems.forEach(item => {
            item.classList.add('ec-predictive-search__suggestion-item');
            const link = item.querySelector('.predictive-search__item');
            if (link) {
              link.classList.add('ec-predictive-search__suggestion-link');
              const text = link.querySelector('.predictive-search__item-heading, .predictive-search__item-query-result');
              if (text && !text.classList.contains('ec-predictive-search__suggestion-text')) {
                text.classList.add('ec-predictive-search__suggestion-text');
              }
            }
          });
        }
        
        const suggestionsProductsContainer = searchPredictiveResults.querySelector('.ec-predictive-search__product-suggestions');
        if (suggestionsProductsContainer) {
          const suggestionsTitle = suggestionsProductsContainer.querySelector('.ec-predictive-search__suggestions-title');
          if (suggestionsTitle) {
            suggestionsTitle.classList.add('ec-predictive-search__heading');
          }
        }
        const suggestionsProductsList = searchPredictiveResults.querySelector('#predictive-search-results-suggestions-products-list');
        if (suggestionsProductsList) {
          suggestionsProductsList.classList.add('ec-predictive-search__suggestions-products-list');
          const suggestionProductItems = suggestionsProductsList.querySelectorAll('.predictive-search__list-item');
          suggestionProductItems.forEach(item => {
            item.classList.add('ec-predictive-search__suggestion-product-item');
            const link = item.querySelector('.predictive-search__item');
            if (link) {
              link.classList.add('ec-predictive-search__suggestion-product-link');
              const heading = link.querySelector('.predictive-search__item-heading');
              if (heading) {
                heading.classList.add('ec-predictive-search__suggestion-product-name');
              }
            }
          });
        }
        
        const productItems = searchPredictiveResults.querySelectorAll('#predictive-search-results-products-list .predictive-search__item--link-with-thumbnail');
        productItems.forEach(item => {
          item.classList.add('ec-predictive-search__product-link');
          const img = item.querySelector('.predictive-search__image');
          if (img && !img.closest('.ec-predictive-search__product-image-wrapper')) {
            const wrapper = document.createElement('div');
            wrapper.className = 'ec-predictive-search__product-image-wrapper';
            img.parentNode.insertBefore(wrapper, img);
            wrapper.appendChild(img);
            img.classList.add('ec-predictive-search__product-image');
          }
          const content = item.querySelector('.predictive-search__item-content');
          if (content) {
            content.classList.add('ec-predictive-search__product-content');
            const heading = content.querySelector('.predictive-search__item-heading');
            if (heading) {
              heading.classList.add('ec-predictive-search__product-name');
            }
            const priceContainer = content.querySelector('.price');
            if (priceContainer) {
              priceContainer.classList.add('ec-predictive-search__product-price');
            }
          }
        });
        
        const productsList = searchPredictiveResults.querySelector('#predictive-search-results-products-list');
        if (productsList) {
          productsList.classList.add('ec-predictive-search__products-list');
        }
        
        const resultsGroupsWrapper = searchPredictiveResults.querySelector('.predictive-search__results-groups-wrapper');
        if (resultsGroupsWrapper) {
          resultsGroupsWrapper.classList.add('ec-predictive-search__results-groups-wrapper');
          if (resultsGroupsWrapper.classList.contains('predictive-search__results-groups-wrapper--no-products')) {
            resultsGroupsWrapper.classList.add('ec-predictive-search__results-groups-wrapper--no-products');
          }
          if (resultsGroupsWrapper.classList.contains('predictive-search__results-groups-wrapper--no-suggestions')) {
            resultsGroupsWrapper.classList.add('ec-predictive-search__results-groups-wrapper--no-suggestions');
          }
        }
        
        const groups = searchPredictiveResults.querySelectorAll('.predictive-search__result-group');
        groups.forEach(group => {
          group.classList.add('ec-predictive-search__group');
        });
        
        const headings = searchPredictiveResults.querySelectorAll('.predictive-search__heading');
        headings.forEach(heading => {
          heading.classList.add('ec-predictive-search__heading');
        });
        
        const items = searchPredictiveResults.querySelectorAll('li[role="option"]');
        items.forEach((item, index) => {
          if (!item.id) {
            item.id = `ec-predictive-option-${index}`;
          }
        });
        
        const searchForButton = searchPredictiveResults.querySelector('#predictive-search-option-search-keywords .predictive-search__item--term');
        if (searchForButton) {
          searchForButton.classList.add('ec-predictive-search__search-all-button');
          
          searchForButton.onclick = (e) => {
            e.preventDefault();
            const input = document.querySelector('.ec-header__search-input');
            if (input && input.value.trim()) {
              const searchUrl = window.Shopify?.routes?.search_url || '/search';
              window.location.href = `${searchUrl}?q=${encodeURIComponent(input.value.trim())}`;
            }
          };
        }
      }
      
      if (searchPredictive) {
        const searchForButtonParent = searchPredictive.querySelector('#predictive-search-option-search-keywords .predictive-search__item--term:not(.ec-predictive-search__search-all-button)');
        if (searchForButtonParent) {
          searchForButtonParent.classList.add('ec-predictive-search__search-all-button');
        }
      }
      
      clearSelection();
    };
    
    const switchOption = (direction) => {
      if (!searchPredictive || searchPredictive.style.display === 'none') return;
      
      const moveUp = direction === 'up';
      const selectedElement = searchPredictive.querySelector('[aria-selected="true"]');
      
      const allVisibleElements = Array.from(
        searchPredictive.querySelectorAll('li[role="option"], button.predictive-search__item')
      ).filter((element) => element.offsetParent !== null);
      
      if (allVisibleElements.length === 0) return;
      
      let activeElementIndex = 0;
      let selectedElementIndex = -1;
      
      if (selectedElement) {
        selectedElementIndex = allVisibleElements.indexOf(selectedElement);
      }
      
      if (moveUp) {
        if (selectedElementIndex === -1) return;
        activeElementIndex = selectedElementIndex === 0 
          ? allVisibleElements.length - 1 
          : selectedElementIndex - 1;
      } else {
        activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 
          ? 0 
          : selectedElementIndex + 1;
      }
      
      const activeElement = allVisibleElements[activeElementIndex];
      
      if (selectedElement) {
        selectedElement.setAttribute('aria-selected', 'false');
      }
      activeElement.setAttribute('aria-selected', 'true');
      if (activeElement.id) {
        searchInputHeader.setAttribute('aria-activedescendant', activeElement.id);
      }
      
      activeElement.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    };
    
    const selectOption = () => {
      const selectedOption = searchPredictive?.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
      
      if (selectedOption) {
        selectedOption.click();
      } else if (currentSearchTerm && searchInputHeader) {
        searchInputHeader.form.submit();
      }
    };
    
    const handleSearchInput = (e) => {
      const searchTerm = e.target.value.trim();
      currentSearchTerm = searchTerm;
      
      clearSelection();
      
      if (searchTerm.length >= 2) {
        getPredictiveSearchResults(searchTerm);
      } else {
        if (searchDefault) searchDefault.style.display = 'block';
        if (searchPredictive) searchPredictive.style.display = 'none';
      }
    };
    
    const debouncedSearch = typeof debounce !== 'undefined' 
      ? debounce(handleSearchInput, 300)
      : ((e) => {
          clearTimeout(searchTimeout);
          searchTimeout = setTimeout(() => handleSearchInput(e), 300);
        });
    
    searchInputHeader.addEventListener('input', debouncedSearch);
    
    searchInputHeader.addEventListener('keydown', (e) => {
      if (!searchPredictive || searchPredictive.style.display === 'none') return;
      
      switch (e.key) {
        case 'ArrowUp':
          e.preventDefault();
          switchOption('up');
          break;
        case 'ArrowDown':
          e.preventDefault();
          switchOption('down');
          break;
        case 'Enter':
          const selected = searchPredictive.querySelector('[aria-selected="true"]');
          if (selected) {
            e.preventDefault();
            selectOption();
          }
          break;
        case 'Escape':
          break;
      }
    });
    
    window.ecPredictiveSearchCleanup = function() {
      if (abortController) {
        abortController.abort();
        abortController = null;
      }
      if (searchDefault) searchDefault.style.display = 'block';
      if (searchPredictive) searchPredictive.style.display = 'none';
      if (searchPredictiveResults) searchPredictiveResults.innerHTML = '';
      currentSearchTerm = '';
      clearSelection();
      if (searchInputHeader) {
        searchInputHeader.setAttribute('aria-expanded', 'false');
      }
    };
  });
})();
